<template>
  <div class="module-wrapperfh">
    <div class="titlev">
      <div class="holdTitleVname" @click="mainClick">{{title}}
         <img src="@/assets/right-arrow-gray.png"
         v-if="subtitle === ''"
         alt=""
         class="right-arrow"/>
      </div>
      <div class="holdTitleVs">{{subtitle}} </div>
    </div>
    <div class="table">
          <div v-for="(item, index) in list"
          :key="index">
            <div class="tr">
              <span v-for="(headItem, headIndex) in item.headerData"
                class="th"
                :key="headIndex"
              >{{headItem}}</span>
            </div>
            <div class="tr" v-for="(subItem, index) in item.items"
            :key="index">
              <span class="td">{{confDate(item.type ? subItem.FSRQ : subItem.DJR)}}</span>
              <span class="td">{{item.type ? subItem.CFLX : confDate(subItem.FFR)}}</span>
              <span class="td"
              >{{item.type ? confFHZSBL(subItem.FHFCZ) : confItem(subItem.FHFCZ)}}</span>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import { numeral } from '@fund/basic-lib';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundDividendDistribution',
  components: {
  },
  data() {
    return {
      isShow: true,
      list: {},
      fundCode: '',
      fundType: '',
      title: '分红送配',
      subtitle: '',
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.render();
  },
  methods: {
    mainClick() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '3',
        },
      });
    },
    render() {
      const cache = StoreManger.getFundFHSP();
      this.list = this.handleData(cache);
      if (this.list.length > 0) {
        this.title = '分红送配';
        this.subtitle = '';
      } else {
        this.title = '分红送配';
        this.subtitle = '暂无分红送配';
      }
    },
    handleData(data) {
      if (!data) {
        return [];
      }
      const { FHINFO, FCINFO } = data;
      const res = [];
      if (this.checkData(FHINFO)) {
        if (FHINFO.length > 1) {
          FHINFO.splice(1, FHINFO.length - 1);
        }
        res.push({
          type: 0,
          headerData: ['权益登记日', '分红发放日', '每份分红(元)'],
          items: FHINFO,
        });
      }
      if (FHINFO) {
        if (FHINFO.length > 0) {
          // 有分红不显示拆分
          return res;
        }
      }
      if (this.checkData(FCINFO)) {
        if (FCINFO.length > 1) {
          FCINFO.splice(1, FCINFO.length - 1);
        }
        res.push({
          type: 1,
          headerData: ['拆分折算日', '类型', '比例'],
          items: FCINFO,
        });
      }
      return res;
    },
    fetchCache() {
      const cache = StoreManger.getFundFHSP();
      return this.handleData(cache);
    },
    fetchRequest() {
      return new Promise((resolve) => {
        const resData = this.handleData(StoreManger.getFundFHSP());
        resolve(resData);
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleDefault() {
      // this.pageData = dataModel.objectArrayWithKeyValuesArray([{}], [{}]);
    },
    confItem(value) {
      if (value) {
        return parseFloat(value).toFixed(4);
      }
      return '--';
    },
    confDate(value) {
      if (value && value.length === 10) {
        return value.substring(2, 10);
      }
      return '--';
    },
    confFHZSBL(value) {
      if (value === '--') {
        return '--';
      }
      return `约1:${numeral(value).format('0.0000')}`;
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/FundDividendDistribution',
        params: {
          FCODE: code,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.fh',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
  },
};
</script>

<style scoped lang="less">
.table {
  background-color: #ffffff;
}
.titlev{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.holdTitleVs{
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  letter-spacing: 0;
  line-height: 28px;
}
.holdTitleVname{
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  line-height: 28px;
}
.module-wrapperfh {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 18px;
  margin-left: 24px;
  margin-right: 24px;
}
.tr {
  padding: 15px 0 15px 0;
  display: flex;
  justify-content: space-between;
  &:nth-last-child(1) {
    &:after{
      display: none;
    }
  }
}

.th {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 28px;
  width: 33.3%;

  &:nth-child(1) {
    text-align: left;
  }
  &:nth-child(2) {
    text-align: center;
  }
  &:nth-last-child(1) {
    text-align: right;
  }
}

.right-arrow {
  margin-left: 5px;
  width: 32px;
  height: 32px;
}
.td {
  width: 33.3%;
  font-family: DINAlternate-Bold;
  font-size: 32px;
  color: #000000;
  line-height: 32px;

  &:nth-child(1) {
    text-align: left;
  }

  &:nth-child(2) {
    text-align: center;
  }
  &:nth-last-child(1) {
    text-align: right;
  }
}
</style>
